<template>
  <el-dialog
    custom-class="question-review-msg-box"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="500px"
    :title="title"
    :visible.sync="visible"
    @keyup.enter.native="onSubmit()">
    <!-- 自定义赏金 -->
    <custom-salary
      v-if="components.customSalary && visible"
      :salary="salary"
      :settlement-detail="settlementDetail"
      :orderDetail="orderDetail"
      @change="onSalaryChange"/>
    <div style="margin-top: 10px;"
         v-if="components.customSalary && components.message"></div>
    <!-- 请输入通过原因 -->
    <el-input
      v-if="components.message"
      :autosize="{ minRows: 1}"
      type="textarea"
      placeholder="请输入通过原因"
      v-model="message"
      resize="none"></el-input>
    <div v-if="marketPhotos.length">
      <br><br>
      <div><b>请选一张正面且清晰的照片，作为门店的参考门头照在任务的详情页展示</b></div>
      <br>
      <div class="question-detail-img" v-perfect-scrollbar.relative="{wheelPropagation:true,suppressScrollY:true}">
        <ul>
          <li
            v-for="(pic, index) in marketPhotos"
            :key="pic.src + index"
            @click="onViewImage(index, marketPhotos)">
            <img :src="pic.src|ossHost(imgUrlSuffix)"
                 alt="">
            <i v-if="pic.selected" class="el-icon-success color-success selected-mark"></i>
          </li>
        </ul>
      </div>
    </div>
    <p style="margin: 20px 0 0 0;">本次审核共计修改选择题答案题数：{{changeSelectedIndexes.length}}</p>
    <div slot="footer"
         class="dialog-footer">
      <order-rank v-if="orderDetail.marketid > 0 && settleDetail.percent === 100" style="flex: 1" :orderDetail="orderDetail" v-model="rankScore" />
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="danger"
                 :disabled="disabled"
                 @click="onSubmit()">确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

import CustomSalary from './CustomSalary'
import questionReview from '@views/question-review/question-review.js'
import MarketPhotoFullScreen from '@views/question-review/components/MarketPhotoFullScreen'
import QuestionReview from '@views/question-review/question-review'

import OrderRank from '@views/order-review/pages/OrderReviewSidebarPanel/OrderRank.vue'

export default {
  mixins: [],
  components: {CustomSalary, MarketPhotoFullScreen, OrderRank},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: Function.prototype,
    },
    salary: {
      type: Number,
      default: 0,
    },
    components: {
      type: Object,
      default: {},
    },
    title: String,
    marketPhotos: {
      type: Array,
      default: [],
    },
    orderDetail: {
      type: Object,
      default: {},
    }
  },
  data () {
    return {
      customSalary: 0,
      settlementDetail: {},
      message: '',
      imgUrlSuffix: '?x-oss-process=image/resize,m_pad,h_70,w_70,color_FFFFFF',
      changeSelectedIndexes: [],
      settleDetail: {},
      rankScore: null
    }
  },
  computed: {
    disabled () {
      return this.components.customSalary &&
        this.customSalary < 0 &&
        this.components.message &&
        !this.message
    },
    marketPhotoIndex () {
      for (let i in this.marketPhotos) {
        if (this.marketPhotos[i].selected) {
          return i * 1
        }
      }
      return null
    }
  },
  watch: {
    visible (val) {
      if (val === false) {
        this.message = ''
      } else {
        this.init()
      }
    },
    salary (salary) {
      this.customSalary = salary
    },
  },
  created () {
  },
  mounted () {},
  destroyed () {},
  methods: {
    init () {
      this.settlementDetail = questionReview().getMiniSettlementAmount(this.salary)
      this.changeSelectedIndexes = questionReview().getIndexesForChangeSelected()
    },
    calculateIsInvalidForTaskGroup () {
      const questions = QuestionReview().getQuestions()
      const answers = QuestionReview().getRecoveryAnswers()

      for (let question of questions) {
        if (question.type !== 'select') {
          continue
        }
        const options = question.options.filter((it) => !!it.autoIncreaseTaskGroupTarget)
        if (!options || options.length <= 0) {
          continue
        }
        const answer = answers.find(it => it.stepId === question.id)
        if (!answer) {
          continue
        }
        if (options.map(it => it.id).includes(answer.selectedOptionId)) {
          return true
        }
      }
      return false
    },
    onSubmit () {
      // 只有门店任务 全额结算 才需要打分
      if (this.orderDetail.marketid > 0 && this.settleDetail.percent === 100 && !this.rankScore) {
        this.$message.error('请对用户做单质量打分')
        return
      }

      if (this.orderDetail.project_platform_type === '2') {
        this.settleDetail.platform_fee_rate = 15
      } else {
        this.settleDetail.platform_fee_rate = 0
      }
      // 把赏金改少并没有给理由时报错
      if ((this.settleDetail.reduced_salary !== this.salary || this.settleDetail.settle_type !== 1) && this.settleDetail.settle_reason === '') {
        this.$message.error('请填写结算理由')
        return
      }
      this.$emit('update:visible', false)
      this.callback({
        salary: this.customSalary,
        message: this.message,
        marketPhotoIndex: this.marketPhotoIndex,
        settle_detail: this.settleDetail,
        rank_score: this.settleDetail.percent === 100 ? this.rankScore : 0,
        is_invalid_for_task_group: this.calculateIsInvalidForTaskGroup(),
      })
    },
    onSalaryChange (salary, settleDetail) {
      this.customSalary = salary
      this.settleDetail = settleDetail
    },
    onViewImage (index, files) {
      let $this = this
      MarketPhotoFullScreen({
        files: files,
        viewIndex: index,
        toolbar: {delete: false},
        chooseOne (index) {
          for (let i in $this.marketPhotos) {
            $this.marketPhotos[i].selected = (i * 1 === index)
          }
        }
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
.dialog-footer {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/ReviewBox/src/OrderConfirm.vue